import React from 'react';

import { BackButton } from '../../../common/button/back-button/BackButton';
import { BreadCrumbTrail } from '../../../common/breadcrumb-trail/BreadcrumbTrail';
import { CAPAReviewGeneralTab } from './CAPAReviewGeneralTab';

import './CAPAReviewCreate.css';

export const CAPAReviewCreate = ({ context, navigateTo, showToaster, setSpinnerText, toolTipsEnabled }) => {
  return (
    <div className="clients-create-container">
      <div className="clients-create-header-container">
        <BackButton onClick={() => navigateTo('capaReviewsTable')} />
        <h2>Create New CAPA Review</h2>
      </div>

      <div className="wizard-content-container">
        <div className="wizard-main-content-container">
          <div className="clients-create-container">
            <div className="clients-create-tab-container">
              <div className="clients-create-tab general active-tab">General</div>
            </div>

            <div className="clients-create-tab-content capaReviewCreateGeneral">
              <CAPAReviewGeneralTab
                context={context}
                navigateTo={navigateTo}
                setSpinnerText={setSpinnerText}
                showToaster={showToaster}
                toolTipsEnabled={toolTipsEnabled}
                editMode={false}
              />
            </div>
          </div>
        </div>

        <div className="wizard-breadcrumb-container">
          <BreadCrumbTrail context={context} navigateTo={navigateTo} />
        </div>
      </div>
    </div>
  );
};
